import React from "react";
import { CircularProgress } from "Components/Base/Feedback/CircularProgress";
import EmptyState from "Components/Fragment/DataDisplay/EmptyState";
import { ErrorIcon, SEARCH, DatabaseIcon } from "Components/Icons";

export const LoadingState = ({ languageContext }) => (
  <EmptyState icon={<CircularProgress />} title={languageContext("loading")} />
);

export const ErrorState = ({ languageContext, message }) => (
  <EmptyState
    icon={<ErrorIcon />}
    title={languageContext("error")}
    description={message || languageContext("errorLoading")}
  />
);

export const NoResultsState = ({ languageContext, onClearFilters }) => (
  <EmptyState
    icon={<SEARCH />}
    title={languageContext("noResult")}
    description={languageContext("noResultsDescription")}
    actionLabel={languageContext("clearFilters")}
    onAction={onClearFilters}
  />
);

export const NoDataState = ({ languageContext }) => (
  <EmptyState
    icon={<DatabaseIcon />}
    title={languageContext("noData")}
    description={languageContext("noDataDescription")}
  />
);
